import script from "./ViewCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewCourse.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__